import React from "react";
import { LOGO_URL } from "@/lib/brand";

/**
 * StarLoader — premium twinkle loader using the Star Jewels logo.
 *
 * Two nested animations without conflict:
 *   • outer wrapper — slow clockwise rotation via `sj-loader-spin`
 *   • inner <img>   — existing `sj-twinkle` scale+glow keyframes
 * They operate on separate elements so their `transform` properties never fight.
 *
 * Props:
 *   size — pixel size of the star (default 120 — deliberately large)
 *   full — full-height centered block when true
 *   label — accepted for backwards compat; no longer rendered
 */
export default function StarLoader({ size = 120, full = false, className = "", label }) {
  return (
    <div
      className={`flex items-center justify-center ${full ? "min-h-[40vh]" : "py-6"} ${className}`}
      data-testid="star-loader"
      role="status"
      aria-live="polite"
    >
      <div className="sj-loader-spin" style={{ width: size, height: size }}>
        <img
          src={LOGO_URL}
          alt=""
          className="sj-twinkle object-contain w-full h-full"
          draggable={false}
        />
      </div>
      <span className="sr-only">Loading…</span>
    </div>
  );
}
